import { INTENT_TYPES } from '../../../../constants/intentTypes';

import type { IntentDistributionResponse } from './types';

import type { StudentInfo } from '../../../../hooks/useStudentsMap';
const mockStudentIds = [
  'mock-user-01',
  'mock-user-02',
  'mock-user-03',
  'mock-user-04',
  'mock-user-05',
  'mock-user-06',
  'mock-user-07',
  'mock-user-08',
  'mock-user-09',
  'mock-user-10',
  'mock-user-11',
  'mock-user-12',
  'mock-user-13',
  'mock-user-14',
  'mock-user-15',
  'mock-user-16',
  'mock-user-17',
  'mock-user-18',
  'mock-user-19',
  'mock-user-20',
  'mock-user-21',
  'mock-user-22',
  'mock-user-23',
  'mock-user-24',
  'mock-user-25',
  'mock-user-26',
];

export const MOCK_INTENT_DISTRIBUTION_RESPONSE: IntentDistributionResponse = {
  students: [
    // #1 Maria Garcia - Top-right (Motivated): high volume, high quality (sum=180)
    {
      userId: mockStudentIds[0],
      totalMessages: 150,
      intentCounts: {
        [INTENT_TYPES.EXPLANATION_REQUEST]: { totalScore: 50 },
        [INTENT_TYPES.HELP_REQUEST]: { totalScore: 45 },
        [INTENT_TYPES.CURIOUS_EXPLORATION]: { totalScore: 35 },
        [INTENT_TYPES.VERIFICATION]: { totalScore: 30 },
        [INTENT_TYPES.DIRECT_ANSWER_REQUEST]: { totalScore: 20 },
      },
    },
    // #2 Pedro Lopez - Top-left (Bad Use): high volume, low quality (sum=20)
    {
      userId: mockStudentIds[1],
      totalMessages: 120,
      intentCounts: {
        [INTENT_TYPES.OFF_TOPIC]: { totalScore: 8 },
        [INTENT_TYPES.COMPLAINT]: { totalScore: 5 },
        [INTENT_TYPES.INADEQUATE]: { totalScore: 4 },
        [INTENT_TYPES.CONVERSATIONAL]: { totalScore: 3 },
      },
    },
    // #3 Ana Martinez - Bottom-right (Efficient): low volume, high quality (sum=160)
    {
      userId: mockStudentIds[2],
      totalMessages: 8,
      intentCounts: {
        [INTENT_TYPES.EXPLANATION_REQUEST]: { totalScore: 90 },
        [INTENT_TYPES.HELP_REQUEST]: { totalScore: 70 },
      },
    },
    // #4 Juan Rodriguez - Bottom-left (Low Commitment): low volume, low quality (sum=5)
    {
      userId: mockStudentIds[3],
      totalMessages: 5,
      intentCounts: {
        [INTENT_TYPES.OFF_TOPIC]: { totalScore: 5 },
      },
    },
    // #5 Sofia Hernandez - Center: balanced student (sum=100)
    {
      userId: mockStudentIds[4],
      totalMessages: 60,
      intentCounts: {
        [INTENT_TYPES.EXPLANATION_REQUEST]: { totalScore: 35 },
        [INTENT_TYPES.HELP_REQUEST]: { totalScore: 30 },
        [INTENT_TYPES.OFF_TOPIC]: { totalScore: 10 },
        [INTENT_TYPES.VERIFICATION]: { totalScore: 25 },
      },
    },
    // #6 Carlos Diaz - Top area: all 11 intent types present (sum=150)
    {
      userId: mockStudentIds[5],
      totalMessages: 200,
      intentCounts: {
        [INTENT_TYPES.DIRECT_ANSWER_REQUEST]: { totalScore: 20 },
        [INTENT_TYPES.EXPLANATION_REQUEST]: { totalScore: 25 },
        [INTENT_TYPES.OFF_TOPIC]: { totalScore: 8 },
        [INTENT_TYPES.OFF_TOPIC_ACADEMIC]: { totalScore: 7 },
        [INTENT_TYPES.HELP_REQUEST]: { totalScore: 22 },
        [INTENT_TYPES.VERIFICATION]: { totalScore: 18 },
        [INTENT_TYPES.CURIOUS_EXPLORATION]: { totalScore: 20 },
        [INTENT_TYPES.COMPLAINT]: { totalScore: 5 },
        [INTENT_TYPES.INADEQUATE]: { totalScore: 5 },
        [INTENT_TYPES.UNCLASSIFIED]: { totalScore: 10 },
        [INTENT_TYPES.CONVERSATIONAL]: { totalScore: 10 },
      },
    },
    // #7 Laura Torres - Single intent only (sum=120)
    {
      userId: mockStudentIds[6],
      totalMessages: 30,
      intentCounts: {
        [INTENT_TYPES.EXPLANATION_REQUEST]: { totalScore: 120 },
      },
    },
    // #8 Diego Ruiz - Null quality scores (sum=0)
    {
      userId: mockStudentIds[7],
      totalMessages: 50,
      intentCounts: {
        [INTENT_TYPES.OFF_TOPIC]: { totalScore: null },
        [INTENT_TYPES.COMPLAINT]: { totalScore: null },
        [INTENT_TYPES.INADEQUATE]: { totalScore: null },
      },
    },
    // #9 Isabella Moreno - Near Maria (clustering test) (sum=178)
    {
      userId: mockStudentIds[8],
      totalMessages: 148,
      intentCounts: {
        [INTENT_TYPES.EXPLANATION_REQUEST]: { totalScore: 48 },
        [INTENT_TYPES.HELP_REQUEST]: { totalScore: 45 },
        [INTENT_TYPES.CURIOUS_EXPLORATION]: { totalScore: 35 },
        [INTENT_TYPES.VERIFICATION]: { totalScore: 30 },
        [INTENT_TYPES.DIRECT_ANSWER_REQUEST]: { totalScore: 20 },
      },
    },
    // #10 Long name overflow test (sum=80)
    {
      userId: mockStudentIds[9],
      totalMessages: 40,
      intentCounts: {
        [INTENT_TYPES.HELP_REQUEST]: { totalScore: 45 },
        [INTENT_TYPES.EXPLANATION_REQUEST]: { totalScore: 35 },
      },
    },
    // #11 NoAvatar Student - avatar: null (sum=140)
    {
      userId: mockStudentIds[10],
      totalMessages: 35,
      intentCounts: {
        [INTENT_TYPES.VERIFICATION]: { totalScore: 80 },
        [INTENT_TYPES.HELP_REQUEST]: { totalScore: 60 },
      },
    },
    // #12 EmptyIntents Student - zero messages (sum=0)
    {
      userId: mockStudentIds[11],
      totalMessages: 0,
      intentCounts: {},
    },
    // #13 Elena - Right (sum=160)
    {
      userId: mockStudentIds[12],
      totalMessages: 90,
      intentCounts: {
        [INTENT_TYPES.EXPLANATION_REQUEST]: { totalScore: 90 },
        [INTENT_TYPES.VERIFICATION]: { totalScore: 70 },
      },
    },
    // #14 Miguel - Bottom-left (sum=10)
    {
      userId: mockStudentIds[13],
      totalMessages: 15,
      intentCounts: {
        [INTENT_TYPES.OFF_TOPIC]: { totalScore: 6 },
        [INTENT_TYPES.CONVERSATIONAL]: { totalScore: 4 },
      },
    },
    // #15 Carmen - Right (sum=140)
    {
      userId: mockStudentIds[14],
      totalMessages: 75,
      intentCounts: {
        [INTENT_TYPES.HELP_REQUEST]: { totalScore: 80 },
        [INTENT_TYPES.CURIOUS_EXPLORATION]: { totalScore: 60 },
      },
    },
    // #16 Alejandro - Bottom-center (sum=90)
    {
      userId: mockStudentIds[15],
      totalMessages: 22,
      intentCounts: {
        [INTENT_TYPES.DIRECT_ANSWER_REQUEST]: { totalScore: 50 },
        [INTENT_TYPES.EXPLANATION_REQUEST]: { totalScore: 40 },
      },
    },
    // #17 Lucia - Left (sum=25)
    {
      userId: mockStudentIds[16],
      totalMessages: 55,
      intentCounts: {
        [INTENT_TYPES.OFF_TOPIC]: { totalScore: 12 },
        [INTENT_TYPES.COMPLAINT]: { totalScore: 8 },
        [INTENT_TYPES.HELP_REQUEST]: { totalScore: 5 },
      },
    },
    // #18 Pablo - Bottom-right (sum=130)
    {
      userId: mockStudentIds[17],
      totalMessages: 10,
      intentCounts: {
        [INTENT_TYPES.VERIFICATION]: { totalScore: 130 },
      },
    },
    // #19 Valentina - Right (sum=155)
    {
      userId: mockStudentIds[18],
      totalMessages: 85,
      intentCounts: {
        [INTENT_TYPES.EXPLANATION_REQUEST]: { totalScore: 70 },
        [INTENT_TYPES.HELP_REQUEST]: { totalScore: 50 },
        [INTENT_TYPES.VERIFICATION]: { totalScore: 35 },
      },
    },
    // #20 Mateo - Center-right (sum=110)
    {
      userId: mockStudentIds[19],
      totalMessages: 42,
      intentCounts: {
        [INTENT_TYPES.CURIOUS_EXPLORATION]: { totalScore: 65 },
        [INTENT_TYPES.EXPLANATION_REQUEST]: { totalScore: 45 },
      },
    },
    // #21 Daniela - Left (sum=30)
    {
      userId: mockStudentIds[20],
      totalMessages: 68,
      intentCounts: {
        [INTENT_TYPES.OFF_TOPIC]: { totalScore: 15 },
        [INTENT_TYPES.INADEQUATE]: { totalScore: 10 },
        [INTENT_TYPES.CONVERSATIONAL]: { totalScore: 5 },
      },
    },
    // #22 Adrian - Center-left (sum=50)
    {
      userId: mockStudentIds[21],
      totalMessages: 30,
      intentCounts: {
        [INTENT_TYPES.HELP_REQUEST]: { totalScore: 30 },
        [INTENT_TYPES.DIRECT_ANSWER_REQUEST]: { totalScore: 20 },
      },
    },
    // #23 Camila - Right (sum=170)
    {
      userId: mockStudentIds[22],
      totalMessages: 50,
      intentCounts: {
        [INTENT_TYPES.EXPLANATION_REQUEST]: { totalScore: 70 },
        [INTENT_TYPES.VERIFICATION]: { totalScore: 55 },
        [INTENT_TYPES.CURIOUS_EXPLORATION]: { totalScore: 45 },
      },
    },
    // #24 Nicolas - Bottom-left (sum=15)
    {
      userId: mockStudentIds[23],
      totalMessages: 18,
      intentCounts: {
        [INTENT_TYPES.OFF_TOPIC_ACADEMIC]: { totalScore: 9 },
        [INTENT_TYPES.UNCLASSIFIED]: { totalScore: 6 },
      },
    },
    // #25 Paula - Right (sum=120)
    {
      userId: mockStudentIds[24],
      totalMessages: 38,
      intentCounts: {
        [INTENT_TYPES.HELP_REQUEST]: { totalScore: 50 },
        [INTENT_TYPES.EXPLANATION_REQUEST]: { totalScore: 45 },
        [INTENT_TYPES.VERIFICATION]: { totalScore: 25 },
      },
    },
    // #26 Roberto - High-volume outlier to trigger log scale (sum=200)
    {
      userId: mockStudentIds[25],
      totalMessages: 1500,
      intentCounts: {
        [INTENT_TYPES.EXPLANATION_REQUEST]: { totalScore: 80 },
        [INTENT_TYPES.HELP_REQUEST]: { totalScore: 60 },
        [INTENT_TYPES.CURIOUS_EXPLORATION]: { totalScore: 40 },
        [INTENT_TYPES.DIRECT_ANSWER_REQUEST]: { totalScore: 20 },
      },
    },
  ],
};

const mockStudentInfos: [string, StudentInfo][] = [
  [mockStudentIds[0], { name: 'Maria', lastName: 'Garcia', avatar: 'https://i.pravatar.cc/150?u=mock01', groupName: 'Class A' }],
  [mockStudentIds[1], { name: 'Pedro', lastName: 'Lopez', avatar: 'https://i.pravatar.cc/150?u=mock02', groupName: 'Class A' }],
  [mockStudentIds[2], { name: 'Ana', lastName: 'Martinez', avatar: 'https://i.pravatar.cc/150?u=mock03', groupName: 'Class A' }],
  [mockStudentIds[3], { name: 'Juan', lastName: 'Rodriguez', avatar: 'https://i.pravatar.cc/150?u=mock04', groupName: 'Class B' }],
  [mockStudentIds[4], { name: 'Sofia', lastName: 'Hernandez', avatar: 'https://i.pravatar.cc/150?u=mock05', groupName: 'Class B' }],
  [mockStudentIds[5], { name: 'Carlos', lastName: 'Diaz', avatar: 'https://i.pravatar.cc/150?u=mock06', groupName: 'Class A' }],
  [mockStudentIds[6], { name: 'Laura', lastName: 'Torres', avatar: 'https://i.pravatar.cc/150?u=mock07', groupName: 'Class B' }],
  [mockStudentIds[7], { name: 'Diego', lastName: 'Ruiz', avatar: 'https://i.pravatar.cc/150?u=mock08', groupName: 'Class A' }],
  [mockStudentIds[8], { name: 'Isabella', lastName: 'Moreno', avatar: 'https://i.pravatar.cc/150?u=mock09', groupName: 'Class A' }],
  [
    mockStudentIds[9],
    { name: 'VeryLongFirstNameStudent', lastName: 'VeryLongLastNameForTesting', avatar: 'https://i.pravatar.cc/150?u=mock10', groupName: 'Class B' },
  ],
  [mockStudentIds[10], { name: 'NoAvatar', lastName: 'Student', avatar: null, groupName: 'Class A' }],
  [mockStudentIds[11], { name: 'EmptyIntents', lastName: 'Student', avatar: null, groupName: 'Class B' }],
  [mockStudentIds[12], { name: 'Elena', lastName: 'Sanchez', avatar: 'https://i.pravatar.cc/150?u=mock13', groupName: 'Class A' }],
  [mockStudentIds[13], { name: 'Miguel', lastName: 'Fernandez', avatar: 'https://i.pravatar.cc/150?u=mock14', groupName: 'Class B' }],
  [mockStudentIds[14], { name: 'Carmen', lastName: 'Gonzalez', avatar: 'https://i.pravatar.cc/150?u=mock15', groupName: 'Class A' }],
  [mockStudentIds[15], { name: 'Alejandro', lastName: 'Perez', avatar: 'https://i.pravatar.cc/150?u=mock16', groupName: 'Class B' }],
  [mockStudentIds[16], { name: 'Lucia', lastName: 'Romero', avatar: 'https://i.pravatar.cc/150?u=mock17', groupName: 'Class A' }],
  [mockStudentIds[17], { name: 'Pablo', lastName: 'Navarro', avatar: 'https://i.pravatar.cc/150?u=mock18', groupName: 'Class B' }],
  [mockStudentIds[18], { name: 'Valentina', lastName: 'Castillo', avatar: 'https://i.pravatar.cc/150?u=mock19', groupName: 'Class A' }],
  [mockStudentIds[19], { name: 'Mateo', lastName: 'Gil', avatar: 'https://i.pravatar.cc/150?u=mock20', groupName: 'Class B' }],
  [mockStudentIds[20], { name: 'Daniela', lastName: 'Ortiz', avatar: 'https://i.pravatar.cc/150?u=mock21', groupName: 'Class A' }],
  [mockStudentIds[21], { name: 'Adrian', lastName: 'Mendez', avatar: 'https://i.pravatar.cc/150?u=mock22', groupName: 'Class B' }],
  [mockStudentIds[22], { name: 'Camila', lastName: 'Vargas', avatar: 'https://i.pravatar.cc/150?u=mock23', groupName: 'Class A' }],
  [mockStudentIds[23], { name: 'Nicolas', lastName: 'Ramos', avatar: 'https://i.pravatar.cc/150?u=mock24', groupName: 'Class B' }],
  [mockStudentIds[24], { name: 'Paula', lastName: 'Flores', avatar: 'https://i.pravatar.cc/150?u=mock25', groupName: 'Class A' }],
  [mockStudentIds[25], { name: 'Roberto', lastName: 'Silva', avatar: 'https://i.pravatar.cc/150?u=mock26', groupName: 'Class B' }],
];

export const MOCK_STUDENTS_MAP: Map<string, StudentInfo> = new Map(mockStudentInfos);
